/**
 * Per-user memory API.
 * Path scope is JWT-derived server-side — the client never sends an account
 * or user identifier.
 */
import { apiFetch } from './api';

const BASE = '/api/memory';

export async function getMemory(): Promise<string> {
  const { content } = await apiFetch<{ content: string }>(BASE);
  return content;
}

export async function putMemory(content: string): Promise<void> {
  await apiFetch<{ success: boolean }>(BASE, {
    method: 'PUT',
    body: JSON.stringify({ content }),
  });
}
